
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Workorder,
  WorkordersApi,
  ValidationProblemDetails
} from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';
import ScrollIntoView from '@/services/ScrollIntoView';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    ordersApi: 'ordersApi'
  })
})
export default class TransferOrderComponent extends Vue {
  private currentUser!: User;

  private ordersApi!: WorkordersApi;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  reason = '';
  newAssignee = '';
  targetPropertyId = '';
  targetBuilding = '';
  targetTrade = '';

  // https://stackoverflow.com/a/43531779/86860
  isMounted = false;

  private validationProblems: ValidationProblemDetails = {};

  get currentOrderPropertyId() {
    return this.order.propertyId;
  }
  get currentOrderBuilding(): string {
    return this.order.building || '';
  }
  get newPropBuildingOk() {
    if (!this.isMounted) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const picker = this.$refs.buildingPicker as any;
    if (!picker) return false;
    return picker.buildingListContains(this.currentOrderBuilding);
  }

  get currentOrderTrade() {
    return this.order.trade;
  }
  get newPropTradeOk() {
    if (!this.isMounted) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const picker = this.$refs.tradePicker as any;
    if (!picker) return false;
    return picker.tradeListContains(this.currentOrderTrade);
  }

  get readyToTransfer() {
    return (
      (this.newPropBuildingOk || this.targetBuilding !== '') &&
      (this.newPropTradeOk || this.targetTrade !== '') &&
      this.targetPropertyId !== this.order.propertyId
    );
  }

  get canTransfer() {
    if (this.order.orderCategory === 'PM') {
      return false;
    }
    let canTransfer = false;
    this.currentUser.profile.candoq.forEach((candoq: string) => {
      if (candoq.startsWith('Reassign Orders:') && !candoq.endsWith(' None')) {
        canTransfer = true;
      }
    });
    return canTransfer;
  }

  data() {
    return {
      targetPropertyId: undefined,
      targetBuilding: undefined,
      targetTrade: undefined
    };
  }

  async mounted() {
    // https://stackoverflow.com/a/43531779/86860
    this.isMounted = true;
  }

  private successHandler(order: Workorder) {
    if (order && order.workorderId) {
      this.$emit('transferred');
      this.popoverOpen = false;
      this.targetTrade = '';
      this.targetPropertyId = '';
      this.targetBuilding = '';
      this.validationProblems = {};
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      ScrollIntoView('error-display');
    }, 100);
  }

  private transfer() {
    this.ordersApi
      .transferTo({
        workorderEntityTransferCommand: {
          workorderId: this.order.workorderId,
          targetPropertyId: this.targetPropertyId,
          targetTrade: this.targetTrade || this.order.trade,
          targetLocation1: this.targetBuilding || this.order.building
        }
      })
      .then(this.successHandler, this.errorHandler);
  }

  private async cancelTransfer() {
    this.popoverOpen = false;
    this.validationProblems = {};
    this.targetTrade = '';
    this.targetPropertyId = '';
    this.targetBuilding = '';
  }

  popoverOpen = false;
}
